/* import __COLOCATED_TEMPLATE__ from './bom.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type SiteService from '@ebiz/ember-aditools-site/services/aditools-site';
import type OpampService from '../../services/opamps';

interface BomFigureArgs {
  model: BillOfMaterials[];
}

type BillOfMaterials = {
  count: number;
  designators: string;
  value: string;
  prodURL: string | null;
  package: string | null;
  material: string | null;
  tolerance: string;
  italicRow: boolean;
};

export default class BomFigure extends Component<BomFigureArgs> {
  @service('aditools-site') declare siteconfig: SiteService;
  @service declare intl: IntlService;
  @service declare opamps: OpampService;

  get bomTable(): BillOfMaterials[] {
    const returnTable = [];
    const table = this.args.model;
    if (table) {
      for (let i = 0; i < table.length; i++) {
        if (table[i]) {
          const item = table[i] as BillOfMaterials;
          const count = item.count,
            designators = item.designators,
            value = item.value,
            tolerance = item.tolerance,
            italicRow = item.italicRow;
          let prodURL = item.prodURL,
            pkg = item.package,
            material = item.material;

          // Build Product URL Based on App Origin (https://www.analog.com/{locale}/{part})
          if (prodURL !== null && prodURL.includes('{{homeURL}}')) {
            prodURL = prodURL.replace('{{homeURL}}', `${this.siteconfig['SiteUrl']}/${this.siteconfig.AdiLocale}`);
          }
          // Change Package Details to Conform to Locale Strings on Extra Parts
          if (pkg !== null) {
            if (pkg.includes('{{header}}')) {
              pkg = pkg.replace(
                '{{header}}',
                this.intl.t('figures.billOfMaterials.extra-components.header').toString(),
              );
            } else if (pkg.includes('{{socket}}')) {
              pkg = pkg.replace(
                '{{socket}}',
                this.intl.t('figures.billOfMaterials.extra-components.socket').toString(),
              );
            } else if (pkg.includes('{{jumper}}')) {
              pkg = pkg.replace(
                '{{jumper}}',
                this.intl.t('figures.billOfMaterials.extra-components.jumper').toString(),
              );
            } else if (pkg.includes('{{test-pin}}')) {
              pkg = pkg.replace(
                '{{test-pin}}',
                this.intl.t('figures.billOfMaterials.extra-components.test-pin').toString(),
              );
            } else if (pkg.includes('{{sma-jack}}')) {
              pkg = pkg.replace(
                '{{sma-jack}}',
                this.intl.t('figures.billOfMaterials.extra-components.sma-jack').toString(),
              );
            } else if (pkg.includes('{{sma-male}}')) {
              pkg = pkg.replace(
                '{{sma-male}}',
                this.intl.t('figures.billOfMaterials.extra-components.sma-male').toString(),
              );
            }
          }
          // Check for Materials if it needs translation
          if (material !== null) {
            if (material.includes('{{tantalum}}')) {
              material = material.replace(
                '{{tantalum}}',
                this.intl.t('figures.billOfMaterials.materials.tantalum').toString(),
              );
            }
          }
          // Push item to array
          returnTable.push({
            count: count,
            designators: designators,
            value: value,
            prodURL: prodURL,
            package: pkg,
            material: material,
            tolerance: tolerance,
            italicRow: italicRow,
          });
        }
      }
    }
    return returnTable;
  }
}
